import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import DocumentRepositoryLoanListPageUI from './DocumentRepositoryLoanListPageUI.js'

class DocumentRepositoryLoanListPageSF extends Component {
constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loanList: null,
      downloadingAll: false,
    }
  }

  render() {
    return (
      <DocumentRepositoryLoanListPageUI
        context={this.props.context}
        account={this.state.account}
        errorList={this.state.errorList}
        loanList={this.state.loanList}
        onRefreshClick={this.onRefreshClick}
        onDownloadAllClick={this.onDownloadAllClick}
        downloadingAll={this.state.downloadingAll}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccount(context)
    this.getLoans(context)
  }

  getLoans(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/loans`,
      cacheKey: CacheKeys.AccountLoans(this.props.match.params.accountId),
      callback: this.getLoansCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoansCallback = (response) => {
    this.setState({ errorList: response.errorList, loanList: response.loanList })
  }

  getAccount(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountCallback = (response) => {
    this.setState({ account: response.account })
  }

onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.AccountLoans(this.props.match.params.accountId))
    this.setState({ loanList: null, errorList: null },
      this.getLoans(this.props.context)
    )
  }

  onDownloadAllClick = () => {
    if (this.state.downloadingAll)
      return
    this.setState({ downloadingAll: true })
    let context = this.props.context
    let accountId = this.props.match.params.accountId
    let RestApiUtils = require('../../../apiclient/moebli/RestApiUtils').default
    let getResource = `${RestApiUtils.getServerUrl(context)}/api/su/accounts/${accountId}/documentRepository/downloadAll`

    fetch(getResource, { headers: RestApiUtils.getHeaders(context) })
      .then((response) => {
        if (!response.ok)
          throw new Error('Download failed')
        return response.blob()
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = 'account_documents.zip'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        this.setState({ downloadingAll: false })
      })
      .catch(() => {
        this.setState({ downloadingAll: false, errorList: [{ message: 'Download failed. Please try again.' }] })
      })
  }
}

export default withRouter(DocumentRepositoryLoanListPageSF)
